import React, {
    createContext,
    PropsWithChildren,
    useContext,
    useMemo,
} from 'react';
import { PathUtils } from '@adobe/aem-spa-page-model-manager';

export type TFeatureFlagContext = {
    getFeatureFlags: (
        flagIdentifier: string,
    ) => { [key: string]: boolean } | boolean;
};

export const FeatureFlagContext = createContext({
    getFeatureFlags: (identifier: string) => {
        // eslint-disable-next-line
        console.debug(
            'Feature Flags Not Initialised, Identifier Called: ' + identifier,
        );
        return false;
    },
} as TFeatureFlagContext);

export const useFeatureFlags = () => useContext(FeatureFlagContext);

export default function FeatureFlagProvider({
    children,
}: PropsWithChildren<{}>) {
    return (
        <FeatureFlagContext.Provider
            value={useMemo(() => {
                const featureFlags = JSON.parse(
                    PathUtils.getMetaPropertyValue('featureFlagsProvider') ||
                        '{}',
                );

                return {
                    getFeatureFlags: (flagIdentifier: string) => {
                        if (flagIdentifier in featureFlags) {
                            return featureFlags[flagIdentifier];
                        }
                        return false;
                    },
                };
            }, [])}
        >
            {children}
        </FeatureFlagContext.Provider>
    );
}
